import { Reply, ReplyId, toReplyId } from '../model/reply.types';

export type ReplyThread = {
  reply: Reply;
  children: Reply[];
};

export const isLevelOneReply = (reply: Reply, postId: string): boolean =>
  reply.parentId === null || reply.parentId === postId;

export const threadParentId = (reply: Reply, postId: string): ReplyId =>
  reply.parentId === null || reply.parentId === postId
    ? reply.id
    : toReplyId(reply.parentId);

export const groupReplies = (
  replies: Reply[],
  postId: string,
): ReplyThread[] => {
  const threads: ReplyThread[] = [];
  const threadsByReplyId = new Map<string, ReplyThread>();

  for (const reply of replies) {
    if (!isLevelOneReply(reply, postId)) continue;
    const thread = { reply, children: [] };
    threads.push(thread);
    threadsByReplyId.set(reply.id, thread);
  }

  const orphans: ReplyThread[] = [];
  for (const reply of replies) {
    if (isLevelOneReply(reply, postId)) continue;
    const parentThread =
      reply.parentId === null
        ? undefined
        : threadsByReplyId.get(reply.parentId);
    if (parentThread) {
      parentThread.children.push(reply);
    } else {
      orphans.push({ reply, children: [] });
    }
  }

  for (const thread of threads) {
    thread.children.sort(
      (a, b) => a.createdAt.getTime() - b.createdAt.getTime(),
    );
  }

  return [...threads, ...orphans];
};
